import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Btn } from "../components/kit";
import { ConfirmDialog } from "../components/common";
import { api, parseError } from "../lib/api";
import { fmtDateTime } from "../lib/format";

export function MergeBar({ responses, selected, onDone }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const picked = responses.filter((r) => selected.includes(r.id)).sort((a, b) => a.created_at.localeCompare(b.created_at));
  const [keep, setKeep] = useState(null);
  const keepId = keep && selected.includes(keep) ? keep : picked[0]?.id;
  const run = async () => {
    try {
      for (const r of picked.filter((x) => x.id !== keepId)) await api.post("/responses/merge", { keep_id: keepId, duplicate_id: r.id, confirm: true });
      toast.success(t("p3.merged_ok"));
      onDone();
    } catch (e) { toast.error(t(`err.${parseError(e).code}`, { defaultValue: t("err.unknown") })); }
  };
  if (responses.filter((r) => !r.merged_into).length < 2) return null;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="merge-bar">
      <Btn variant="outline" testid="merge-reports-btn" disabled={picked.length < 2} onClick={() => setOpen(true)}>{t("p3.merge_dups")} ({picked.length})</Btn>
      {picked.length < 2 && <span className="text-sm text-muted-foreground">{t("p3.merge_need_two")}</span>}
      <ConfirmDialog open={open} onOpenChange={setOpen} title={t("p3.merge_dups")} consequence={t("p3.merge_confirm")} confirmLabel={t("p3.merge_dups")} testid="merge-reports-dialog" onConfirm={run}>
        <fieldset className="space-y-2"><legend className="mb-1 text-sm font-semibold">{t("p3.merge_keep")}</legend>
          {picked.map((r) => <label key={r.id} className="flex min-h-[44px] items-center gap-2 rounded-xl border bg-white px-3 text-sm">
            <input type="radio" name="keep" checked={keepId === r.id} onChange={() => setKeep(r.id)} data-testid={`merge-keep-${r.number}`} />{r.number} · {r.owner_name} · {fmtDateTime(r.created_at)}</label>)}
        </fieldset>
      </ConfirmDialog>
    </div>
  );
}

export function MergeInfo({ r, responses }) {
  const { t } = useTranslation();
  const num = (id) => responses.find((x) => x.id === id)?.number || id.slice(0, 6);
  return <>
    {r.merged_into && <p className="text-sm font-semibold" data-testid={`merged-into-${r.number}`}>{t("p3.merged_into", { n: num(r.merged_into) })} · {fmtDateTime(r.merged_at)}</p>}
    {r.merged_from?.length > 0 && <p className="text-sm" data-testid={`merged-from-${r.number}`}>{t("p3.merged_from", { n: r.merged_from.map(num).join(", ") })}</p>}
  </>;
}
